import { Component, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { interval, Subscription } from 'rxjs';

interface Blog {
  id: number;
  title: string;
  imageLink: string;
  content: string;
  points: string[];
  ctaLink: string;
}

@Component({
  selector: 'app-blogs',
  templateUrl: './blogs.component.html',
  styleUrls: ['./blogs.component.scss'],
  standalone: false,
})
export class BlogsComponent {
  activeIndex = 0;
  progress = 0;
  private progressSubscription: Subscription | null = null;
  private slideSubscription: Subscription | null = null;

  blogs: Blog[] = [
    {
      id: 1,
      title: 'How Inforida makes teacher lives easier.',
      imageLink:
        'https://blog.inforida.com/content/images/size/w2000/2024/05/pexels-emily-ranquist-493228-1205651.jpg',
      content:
        "Teachers, you're the heart and soul of education, dedicating endless hours to shaping young minds. But let’s face it—between lesson planning, attendance tracking, and administrative tasks, the workload can feel overwhelming. That’s where Inforida steps in, transforming the way teachers manage their day-to-day responsibilities.Teachers, you're the heart and soul of education, dedicating endless hours to shaping young minds. But let’s face it—between lesson planning, attendance tracking, and administrative tasks, the workload can feel overwhelming. That’s where Inforida steps in, transforming the way teachers manage their day-to-day responsibilities.Teachers, you're the heart and soul of education, dedicating endless hours to shaping young minds. But let’s face it—between lesson planning, attendance tracking, and administrative tasks, the workload can feel overwhelming. That’s where Inforida steps in, transforming the way teachers manage their day-to-day responsibilities.",
      points: [
        '1. Streamlined Administrative Tasks',
        'Inforida automates time-consuming processes like attendance, grading, and performance reporting. Instead of juggling paperwork, teachers can focus on what truly matters—teaching.',
        '2. Real-Time Dashboards for Better Insights',
      ],
      ctaLink:
        'https://blog.inforida.com/navigating-the-cbse-results-2024-insights-and-how-inforida-can-enhance-school-management/',
    },
    {
      id: 2,
      title: "Inforida's AI-Powered Lesson Planning",
      imageLink:
        'https://blog.inforida.com/content/images/size/w2000/2023/02/pexels-pavel-danilyuk-8423051.jpg',
      content:
        "Teachers, you're the heart and soul of education, dedicating endless hours to shaping young minds. But let’s face it—between lesson planning, attendance tracking, and administrative tasks, the workload can feel overwhelming. That’s where Inforida steps in, transforming the way teachers manage their day-to-day responsibilities.Teachers, you're the heart and soul of education, dedicating endless hours to shaping young minds. But let’s face it—between lesson planning, attendance tracking, and administrative tasks, the workload can feel overwhelming. That’s where Inforida steps in, transforming the way teachers manage their day-to-day responsibilities.Teachers, you're the heart and soul of education, dedicating endless hours to shaping young minds. But let’s face it—between lesson planning, attendance tracking, and administrative tasks, the workload can feel overwhelming. That’s where Inforida steps in, transforming the way teachers manage their day-to-day responsibilities.",
      points: [
        '1. Customizable Templates',
        '2. Content Recommendations',
        '3. Standards Alignment',
      ],
      ctaLink:
        'https://blog.inforida.com/the-secret-to-school-success-unlocking-inforidas-powerful-features/',
    },
    {
      id: 3,
      title: 'Student Progress Tracking Made Simple',
      imageLink:
        'https://blog.inforida.com/content/images/size/w2000/2024/05/pexels-tima-miroshnichenko-5428148.jpg',
      content:
        "Teachers, you're the heart and soul of education, dedicating endless hours to shaping young minds. But let’s face it—between lesson planning, attendance tracking, and administrative tasks, the workload can feel overwhelming. That’s where Inforida steps in, transforming the way teachers manage their day-to-day responsibilities.Teachers, you're the heart and soul of education, dedicating endless hours to shaping young minds. But let’s face it—between lesson planning, attendance tracking, and administrative tasks, the workload can feel overwhelming. That’s where Inforida steps in, transforming the way teachers manage their day-to-day responsibilities.Teachers, you're the heart and soul of education, dedicating endless hours to shaping young minds. But let’s face it—between lesson planning, attendance tracking, and administrative tasks, the workload can feel overwhelming. That’s where Inforida steps in, transforming the way teachers manage their day-to-day responsibilities.",
      points: [
        '1. Visual Performance Analytics',
        '2. Individual Learning Paths',
        '3. Parent Communication Tools',
      ],
      ctaLink:
        'https://blog.inforida.com/5-ways-inforida-can-make-teachers-lives-easier-and-more-fulfilling/',
    },
    {
      id: 4,
      title: 'Classroom Management Reimagined',
      imageLink:
        'https://blog.inforida.com/content/images/size/w2000/2024/04/pexels-rdne-stock-project-5922675.jpg',
      content:
        "Teachers, you're the heart and soul of education, dedicating endless hours to shaping young minds. But let’s face it—between lesson planning, attendance tracking, and administrative tasks, the workload can feel overwhelming. That’s where Inforida steps in, transforming the way teachers manage their day-to-day responsibilities.Teachers, you're the heart and soul of education, dedicating endless hours to shaping young minds. But let’s face it—between lesson planning, attendance tracking, and administrative tasks, the workload can feel overwhelming. That’s where Inforida steps in, transforming the way teachers manage their day-to-day responsibilities.Teachers, you're the heart and soul of education, dedicating endless hours to shaping young minds. But let’s face it—between lesson planning, attendance tracking, and administrative tasks, the workload can feel overwhelming. That’s where Inforida steps in, transforming the way teachers manage their day-to-day responsibilities.",
      points: [
        '1. Digital Classroom Setup',
        '2. Behavior Monitoring',
        '3. Resource Management',
      ],
      ctaLink:
        'https://blog.inforida.com/managing-school-finances-with-inforida-a-comprehensive-guide-for-school-administrators/',
    },
  ];

  constructor(@Inject(PLATFORM_ID) private platformId: Object) {}

  ngOnInit(): void {
    this.startProgressAnimation();
    this.startSlideAnimation();
  }

  ngOnDestroy(): void {
    if (this.progressSubscription) {
      this.progressSubscription.unsubscribe();
    }
    if (this.slideSubscription) {
      this.slideSubscription.unsubscribe();
    }
  }

  private startProgressAnimation(): void {
    this.progress = 0;
    if (this.progressSubscription) {
      this.progressSubscription.unsubscribe();
    }

    this.progressSubscription = interval(60).subscribe(() => {
      this.progress += 1;
      if (this.progress >= 100) {
        this.progress = 0;
      }
    });
  }

  private startSlideAnimation(): void {
    if (this.slideSubscription) {
      this.slideSubscription.unsubscribe();
    }

    this.slideSubscription = interval(6000).subscribe(() => {
      this.progress = 0;
      this.activeIndex = (this.activeIndex + 1) % this.blogs.length;
      this.startProgressAnimation();
    });
  }

  getHighlightedTitle(title: string): string {
    return title.replace(
      'Inforida',
      '<span class="text-blue-600">Inforida</span>'
    );
  }
}
